import Flex from '../../Layout/Flex/Flex'
import styled, { css } from 'styled-components'
import { NameWrapperProps, MainWrapperProps, LabelWrapperProps } from './types'
import { FontStyle } from '../../Core/Typography/Font/Font.styles'
import { Svg } from '../../Core/Iconography/Icon/Icon.styles'

export const LabelWrapper = styled.div<LabelWrapperProps>`
  width: ${props => props.width || '100%'};
  height: 100%;
  opacity: ${props => props.disabled ? '0.5' : '1'};
  margin: ${props => props.removeMargin ? '0 8px -1px 8px' : props.margin || '8px'};
  ${props => props.wrapperPadding && css`
    padding: ${props.wrapperPadding};
  `}
  ${props => props.wrapperBoxSizing && css`
    box-sizing: ${props.wrapperBoxSizing};
  `}
`

export const MainWrapper = styled(Flex)<MainWrapperProps>`
  width: 100%;
  height: 100%;
  border: 1px solid ${props => props.error ? props.theme.colors.main.error : props.theme.colors.shades.neutral[1]};
  ${props => props.removeBorder && css`
    border-${props.removeBorder}: 0;
  `}
  box-sizing: border-box;
  ${props => props.labelAsTextInput && css`
    border: none;
    gap: 16px;
  `}
`

export const LabelBlock = styled('div')`
  width: 50%;
  padding: 8px 16px;
  box-sizing: border-box;
`

export const InputLabelWrapper = styled.div<NameWrapperProps>`
    width: ${props => (props.label || props.labelAsTextInput) ? '50%' : '100%'};
    height: 100%;
    padding: 8px 16px;
    border-left: 1px solid ${props => props.theme.colors.shades.neutral[1]};
    box-sizing: border-box;
    display: flex;
    align-items: center;
    ${props => props.labelAsTextInput && css`
      border: none;
      flex-direction: column;
      justify-content: flex-end;
      padding: 0;
    `}
    ${props => props.isDocumentation && css`
      pointer-events: auto;
    `}
`

const shared = css`
  min-height: 48px;
  margin: 8px 0 0 0;
  padding: 8px 16px;
  border: 2px solid ${props => props.theme.colors.shades.neutral[1]};
  border-radius: 4px;
  box-sizing: border-box;
`

//Note: opacity is prefered to hide the file input instead of visibility: hidden or display: none because assistive technology 
// interprets the file input as not interactive with either of the latter two styles applied. Source: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#using_file_inputs
//Note: Elements that can be associated with a <label> element include <button>, <input> (except for type="hidden"), 
// <meter>, <output>, <progress>, <select>and <textarea>.Source: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/label
export const InputStyle = styled.input<{labelAsTextInput?: boolean, labelAsTextInputPlaceholder?: 'string'}>`
  display: none;
  appearance: none;
  ${props => props.labelAsTextInput && css`
    display: block;
    width: 100%;
    ${shared}
    font-size: ${props => props.theme.font.size.h5};
    ::placeholder {
      color: ${props => props.theme.colors.shades.neutral[2]};
      font-size: 14px;
    }
  `}
`

export const NameWrapper = styled(Flex)<NameWrapperProps>`
  width: 100%;
  color: ${props => props.theme.colors.main.ultraViolet};

  ${FontStyle}{
    word-break: break-all;
  }

  ${Svg}:not(:nth-last-child(3)) {
    cursor: pointer;
  }

  ${props => props.labelAsTextInput && css`
    ${shared}
    p {
      width: 75%;
    }
  `}
`
export const MaxSizeSpan = styled('span')<{largeFile?: boolean}>`
    color: ${props => props.largeFile ? props.theme.colors.main.error : props.theme.colors.shades.neutral[2]};
`
